import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from 'antd-mobile'
import { useLocation } from 'react-router-dom'
import { disableBrowserBack } from '../../utils/helper'
const alert = Modal.alert

const NotFound = () => {
    const location = useLocation()
    const { t } = useTranslation()

    useEffect(() => {
        disableBrowserBack()

        const show = alert(
            '',
            location.state?.message || t('message.invalidTable'),
            []
        )
        return () => {
            show.close()
        }
    }, [])

    return <div className="restaurant-not-found"></div>
}

export default NotFound
